import React from "react";
import "../styles/Education.css";
import FUOYE from "../assets/education/FUOYE LOGO.jpeg";
import YSJ from "../assets/education/YSJ LOGO.jpeg";
import { FaGraduationCap, FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";

export default function Education() {
  const education = [
    {
      degree: "M.Sc. Computer Science",
      university: "York St John University",
      location: "London, GB",
      duration: "09/2023 - 09/2024",
      courses: [
        "Agile Software Development",
        "Machine Learning",
        "Artificial Intelligence",
        "Cloud Computing",
        "User Centred Design",
      ],
      logo: YSJ,
    },
    {
      degree: "B.Sc. Accounting",
      university: "Federal University Oye-Ekiti",
      location: "Ekiti, Nigeria",
      duration: "02/2018 - 11/2022",
      courses: [],
      logo: FUOYE,
    },
  ];

  return (
    <section className="education-section">
      <div className="education-container">
        <div className="education-header">
          <h2 className="education-title">Education</h2>
        </div>

        <div className="education-list">
          {education.map((edu, idx) => (
            <div className="education-card" key={idx}>
              <div className="education-header-card">
                <div className="education-logo">
                  <img src={edu.logo} alt={edu.university} />
                </div>
                <div className="education-badge">
                  <FaGraduationCap />
                  {edu.degree.includes("M.Sc") ? "Masters" : "Bachelors"}
                </div>
              </div>

              <div className="education-content">
                <div className="education-degree">{edu.degree}</div>
                <div className="education-university">{edu.university}</div>

                <div className="education-meta">
                  <div className="meta-item">
                    <FaCalendarAlt />
                    <span>{edu.duration}</span>
                  </div>
                  <div className="meta-item">
                    <FaMapMarkerAlt />
                    <span>{edu.location}</span>
                  </div>
                </div>

                {edu.courses.length > 0 && (
                  <div className="education-courses">
                    <div className="courses-label">Relevant courses:</div>
                    <div className="courses-list">
                      {edu.courses.map((course, i) => (
                        <span key={i} className="course-item">
                          {course}
                          {i < edu.courses.length - 1 && ", "}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
